import createModel, { prop } from './lib/create_model';

const VoiceAISessionEnded = createModel({
  modelName: 'VoiceAISessionEnded',

  properties: {
    automationSessionId: prop(String),
    callId: prop(String),
    customerNumber: prop(String),
    companyNumber: prop(String),
    reason: prop(String),
    endedAt: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default VoiceAISessionEnded;
